function brandSectionAssetFormDialog () {
  return {
    restrict: 'E',
    templateUrl: '/brand/dialogs/brand-section-asset-form/brand-section-asset-form-dialog.html?$$REVISION$$'
  }
}
export { brandSectionAssetFormDialog }
